import { message, Select } from "antd";
import { TFeatureWorkflowInstance } from "entity-app/models";

import {
  ErrorMessages,
  ProjectPermissionEnum,
  SuccessMessages
} from "constants/index";
import { useContext } from "react";
import {
  isPermissionNotGrantted,
  ProjectContext
} from "context/ProjectProvider";
import useWorkflowTemplateHook from "./use-workflow-template-hook";

const keyLoadingMessage = "loadingMessagekey";

function ProjectWorkflowTemplateDropdown(props: {
  featureId: number;
  featureWorkflowInstance: TFeatureWorkflowInstance;
  afterChange?: () => void;
  className?: string;
  setApiCallLoading?: (isLoading: boolean) => void;
  disable?: boolean;
}) {
  const {
    featureId,
    featureWorkflowInstance,
    afterChange,
    setApiCallLoading,
    className = "",
    disable = false
  } = props;
  const { tokenContents } = useContext(ProjectContext);
  const cannotChangeTemplate = isPermissionNotGrantted(
    ProjectPermissionEnum.EditWorkflowTemplate,
    tokenContents?.role!
  );

  const {
    options,
    loading,
    selectedMaterialTemplateId,
    setSelectedMaterialTemplateId,
    applyingMDBTemplate,
    isWFStarted,
    applyWorkflowTemplateMutation
  } = useWorkflowTemplateHook({ featureId, featureWorkflowInstance });

  const onTemplateSelectChange = async (templateId: string) => {
    message.loading({
      content: "Recalculating...",
      key: keyLoadingMessage,
      duration: 60000
    });
    setApiCallLoading?.(true);
    setSelectedMaterialTemplateId(templateId);

    const input = [
      {
        feature_instance_id: featureWorkflowInstance.feature_instance_id,
        workflow_instance_id: featureWorkflowInstance.id,
        workflow_template_id: templateId
      }
    ];

    const res = await applyWorkflowTemplateMutation({
      variables: {
        input,
        metadata: {
          request_source: "DETAIL_PAGE"
        }
      }
    });
    if (res.data) {
      message.success({
        content: SuccessMessages.DBTemplateAppliedSuccess,
        key: keyLoadingMessage,
        duration: 3
      });
      if (afterChange) afterChange();
    } else {
      message.error({
        content: ErrorMessages.SomethingWentWrong,
        key: keyLoadingMessage,
        duration: 3
      });
    }
    setApiCallLoading?.(false);
  };

  return (
    <Select
      className={className}
      style={{ minWidth: 160 }}
      options={options}
      value={options.length ? selectedMaterialTemplateId : null}
      onChange={onTemplateSelectChange}
      disabled={
        cannotChangeTemplate || isWFStarted || applyingMDBTemplate || disable
      }
      loading={applyingMDBTemplate || loading}
      placeholder="Select a template"
      data-testid="index-select-template"
    />
  );
}

export default ProjectWorkflowTemplateDropdown;
